import React from 'react';
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import ProspectTasksCustomTabListing
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/ProspectTasksCustomTab/components/ProspectTasksCustomTabListing/ProspectTasksCustomTabListing";
import BaseTaskTab
    from "v4/pages/front/Prospect/components/ProspectTabsSwitcher/components/partials/BaseTaskTab/BaseTaskTab";

export default function ProspectTasksCustomTab() {
    const {currentRoute} = useNavigation();
    const {prospect: prospectId} = currentRoute.params;

    return (
        <BaseTaskTab
            listingComponent={<ProspectTasksCustomTabListing prospectId={prospectId} currentRoute={currentRoute}/>}
            fetchFormParameters={{tabId: currentRoute.route.metadata.tab_id}}
        />
    )
}
